import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
/**
 * Bulk Validate Department Input Schema
 * Input format for validating departments before bulk creation
 */ export const BulkValidateDepartmentInputSchema = z.object({
    name: z.string(),
    description: z.string().optional(),
    abbreviation: z.string(),
    parentAbbreviation: z.string().optional(),
    managerEmail: z.string().email().optional()
});
/**
 * Validated Department Schema
 * Response format for each validated department with resolution results
 */ export const ValidatedDepartmentSchema = z.object({
    rowNumber: z.number(),
    data: z.object({
        name: z.string(),
        description: z.string().optional(),
        abbreviation: z.string(),
        // Parent resolution
        parentAbbreviation: z.string().optional(),
        parentId: z.string().optional(),
        parentSource: z.enum([
            'database',
            'batch'
        ]).optional(),
        // Manager resolution
        managerEmail: z.string().optional(),
        managerId: z.string().optional()
    }),
    isValid: z.boolean(),
    errors: z.array(z.string()).optional(),
    warnings: z.array(z.string()).optional()
});
/**
 * Initialize Validate Departments Request Schema
 * POST /api/v2/initialize/departments/validate
 * Validates departments before creation with tree structure support
 */ export const InitializeValidateDepartmentsRequestSchema = z.object({
    departments: z.array(BulkValidateDepartmentInputSchema)
});
/**
 * Initialize Validate Departments Response Schema
 * Returns validation results with dependency graph and creation order
 */ export const InitializeValidateDepartmentsResponseSchema = z.object({
    departments: z.array(ValidatedDepartmentSchema),
    creationOrder: z.array(z.number()),
    batchValid: z.boolean(),
    totalRows: z.number(),
    validRows: z.number(),
    invalidRows: z.number()
});
/**
 * Initialize Validate Departments Error Schema
 * Returned when validation request fails
 */ export const InitializeValidateDepartmentsErrorSchema = BaseErrorSchema;

//# sourceMappingURL=initialize-validate-departments.schema.js.map